var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Collection',{attrs:{"title":"Counters","add":"true"},on:{"create":_vm.create}},_vm._l((_vm.counters),function(counter,key){return _c('Counter',{key:key,on:{"remove":_vm.remove}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }